import { createSelectors as p } from "@waitroom/state";
import { uniqBy as d } from "@waitroom/utils";
import { createSelector as R } from "reselect";
import { create as m } from "zustand";
const r = () => ({
  lastReaction: void 0,
  reactions: {},
  aggregateReactions: {
    count: {},
    users: {}
  }
}), u = () => ({
  offTheRecordStatus: "DISABLED",
  recordingStatus: "",
  participants: {},
  ...r()
}), f = m()(u), s = p(f), S = (t) => {
  s.setState((e) => ({ ...e, ...t }));
}, h = () => s.setState(u()), B = (t) => {
  S({
    participants: t
  });
}, D = (t, e) => {
  s.setState((a) => ({
    ...a,
    participants: { ...a.participants, [t]: e }
  }));
}, O = (t) => s.setState((e) => {
  const { [t]: a, ...c } = e.participants;
  return {
    ...e,
    participants: c
  };
}), U = (t) => R(
  (e) => e.participants,
  (e) => e[t]
), T = 6, P = 5e3, i = {}, l = (t) => {
  const e = i[t];
  e && clearTimeout(e), i[t] = setTimeout(() => {
    s.setState((a) => ({
      ...a,
      aggregateReactions: {
        count: {
          ...a.aggregateReactions.count,
          [t]: void 0
        },
        users: {
          ...a.aggregateReactions.users,
          [t]: void 0
        }
      }
    }));
  }, P);
}, _ = () => {
  S(r());
  const t = Object.values(i);
  for (let e = 0; e < t.length; e++)
    clearTimeout(t[e]);
}, j = (t, e) => {
  s.setState((a) => {
    var o;
    const c = a.aggregateReactions, g = !e || a.reactions[e.id] === t ? a.reactions : {
      ...a.reactions,
      [e.id]: t
    }, n = ((o = c.count[t]) == null ? void 0 : o[0]) || 0;
    return {
      ...a,
      lastReaction: t,
      reactions: g,
      aggregateReactions: {
        count: { ...c.count, [t]: [n + 1, n] },
        users: e ? {
          ...c.users,
          [t]: d([e, ...c.users[t] || []], "id").slice(
            0,
            T
          )
        } : c.users
      }
    };
  }), l(t);
}, k = (t) => {
  s.setState((e) => ({
    ...e,
    reactions: {
      ...e.reactions,
      [t]: void 0
    }
  }));
};
export {
  j as addReaction,
  U as makeSelectorParticipantMetadata,
  O as removeParticipant,
  k as removeReaction,
  _ as resetReactionsState,
  h as resetStreamState,
  u as streamInitialState,
  D as updateParticipant,
  B as updateParticipants,
  S as updateStreamState,
  s as useStreamStore
};
